<template>
  <div class="content-main">
    <van-loading v-if="loading" class="loading" size="24px" vertical>加载中...</van-loading>

    <div class="records" v-if="!loading">
      <div class="record" v-for="record in records" :key="record.id">
        <div class="record-header flex-box">
          <div class="date">日期：{{record.date}}</div>
          <div class="type">订单编号：{{abbrevTradeNo(record.id)}}</div>
        </div>
        <div class="record-title">{{convertRecordTitle(record.combo)}}</div>
        <div class="price-and-usage flex-box">
          <div class="price">付款金额：¥{{record.price}}</div>
          <!-- <div class="usage-and-remain flex-box">
            <div class="remain" v-if="record.level == 'membership'">{{getRemainHint(record.level)}}</div>
            <div class="usage">{{getUsageHint(record.level)}}</div>
          </div> -->
          <div class="feedback-more flex-box">
            <div class="remain consume" v-if="record.status <3 && record.remain != 0">已用{{record.consume}}条</div>
            <div class="remain" v-if="record.status <3 && record.remain != 0">剩余{{record.remain}}条</div>
            <div class="remain gray" v-if="record.status <3 && record.remain == 0">已完成使用</div>
              <div class="remain red" v-if="record.status == 3">退款中</div>
              <div class="remain red" v-if="record.status == 4">已退款</div>
            <div class="box-more flex-box" v-if="record.remain != 0 && record.status < 3" @click="showFeedbackAction(record.id, record.combo)"><van-icon size="20px" name="ellipsis" /></div>
          </div>
        </div>
      </div>
      <div class="no-more">"没有更多了～"</div>
    </div>

    <van-popup class="feedback-popup" v-model="showFeedbackPopup" position="bottom">
      <div class="title">订单内容：{{ feedbackPopTitle }}</div>
      <div class="feedback-entries">
        <div class="item flex-box" @click="applyRefund()"><van-icon name="paid" />申请退款</div>
      </div>
    </van-popup>

  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { Toast, Dialog, Loading} from 'vant'

export default{
  data(){
    return {
      openid: '',
      records: [],
      loading: true,
      showFeedbackPopup: false,
      feedbackPopTitle: '',
      feedbackOrderId: ''
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    getPaymentRecord(){
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/garden/get_bought', {openid: openid}, res => {
        if(res.code == 200){
          this.loading = false
          this.records = res.items
        }
      })
    },
    convertRecordType(combo){
      if(combo == "a"){
        return "单条留言"
      }else if(combo == "b"){
        return "6元套餐"
      }else if(combo == "c"){
        return "9元套餐"
      }else if(combo == "d"){
        return "19元套餐"
      }
    },
    convertRecordTitle(combo){
      if(combo == "a"){
        return "【单条留言】1元/1条"
      }else if(combo == "b"){
        return "【6元套餐】6元/10条（6条基础留言+4条附赠留言）"
      }else if(combo == "c"){
        return "【9元套餐】9元/20条（9条基础留言+11条附赠留言）"
      }else if(combo == "d"){
        return "【19元套餐】19元/50条（19条基础留言+31条附赠留言）"
      }
    },
    showFeedbackAction(id, combo){
      let title = this.convertRecordTitle(combo)
      this.feedbackPopTitle = title
      this.feedbackOrderId = id
      this.showFeedbackPopup = true
    },
    abbrevTradeNo(text){
      return text.slice(0, 12)
    },
    applyRefund(){
      this.handleRouter('/refund_apply/' + this.feedbackOrderId)
    }
  },
  mounted(){
    this.getPaymentRecord()
  }
}
</script>

<style scoped>
.content-main{
  min-height:100vh;
  background-color: #f8f8f8;
  padding:10px;
}
.loading{margin-top:30%;}
.records{font-size:14px;color:#8d8b8b;}
.records .record{
  background: #fff;
  margin-top: 20px;
  box-shadow: 0 5px 8px 0 rgb(51 51 51 / 5%);
  border-radius: 10px;
  padding:10px;
  border:1px solid #b17e94;
}
.records .record .record-header{font-size:12px;justify-content:space-between;border-bottom:1px solid #d2d6de;padding-bottom:10px;}
.records .record .record-title{font-size:14px;color:#333;font-weight:bold;text-align:left;margin-top:15px;margin-bottom:15px;}
.records .record .price-and-usage{font-size:12px;justify-content:space-between;}
.records .record .remain{border:1px solid #b17e94;border-radius:5px;padding:2px 10px;color:#b17e94;}
.records .record .remain.gray{color:#8d8b8b;border-color:#8d8b8b;}
.records .record .remain.red{color:#ee654e;border-color:#ee654e;}
.records .record .remain.consume{margin-right:10px;}
.records .record .box-more{margin-left:20px;}
.records .no-more{font-size:14px;color:#8590a6;text-align:center;margin-top:20px;}

.feedback-popup{background:#fff;color:#333;font-size:10px;}
.feedback-popup .title{border-bottom:1px solid #f0f0f0;text-align:left;padding:10px;color:#666;}
.feedback-popup .feedback-entries{padding:0px 30px;}
.feedback-popup .item{padding:15px;font-size:14px;justify-content:center;align-items:center;}
.feedback-popup .item .van-icon{margin-right:5px;font-size:16px;font-weight:bold;color:#666;}
</style>
